// Fiche produit MOOLA v2 — remplace le script _slug_ d'Astro du 24/08, branché sur les variantes Shopify.
// Comportement repris : tailles indisponibles BARRÉES (data-available=false), toujours visibles et sélectionnables,
// radios exclusifs par groupe, flèches/Début/Fin au clavier (tabindex itinérant). Ajouté : résolution de la variante,
// prix, ajout au panier en AJAX (/cart/add.js, qui renvoie aussi le panier latéral : il s'ouvre seul — lot 2) puis
// événement « moola:panier » {item_count} écouté par l'en-tête ;
// échec réseau → soumission normale du formulaire (repli). Aucun WhatsApp, aucune liste d'envies.
(() => {
  const fiche = document.querySelector('[data-moola-fiche]');
  const form = document.getElementById('moola-achat');
  const source = document.getElementById('moola-variantes');
  if (!fiche || !form || !source) return;
  const variantes = JSON.parse(source.textContent);
  const champ = form.querySelector('[name="id"]');
  const bouton = form.querySelector('[type="submit"]');
  const etat = form.querySelector('[data-achat-etat]');
  const prix = fiche.querySelector('[data-prix]');
  const aide = fiche.querySelector('[data-size-help]');
  const libCouleur = fiche.querySelector('[data-color-label]');
  const groupes = [...fiche.querySelectorAll('[data-option-index]')];
  const radios = (g) => [...g.querySelectorAll('[role="radio"]')];
  // Prix au format de la BOUTIQUE (shop.money_format, le même que le filtre Liquid « money » des cartes et du rendu
  // serveur) : un Intl.NumberFormat fr-FR afficherait « 69,99 € » au clic là où la page et les cartes disent « €69,99 ».
  const FORMAT = fiche.dataset.monnaie || '{{amount_with_comma_separator}} €';
  const nombre = (c, dec, mil, sepDec) => { const [e, d] = (c / 100).toFixed(dec).split('.'); return e.replace(/\B(?=(\d{3})+(?!\d))/g, mil) + (d ? sepDec + d : ''); };
  const euros = { format: (eur) => { const c = Math.round(eur * 100); return FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
    amount: nombre(c, 2, ',', '.'), amount_no_decimals: nombre(c, 0, ',', '.'),
    amount_with_comma_separator: nombre(c, 2, '.', ','), amount_no_decimals_with_comma_separator: nombre(c, 0, '.', ','),
    amount_with_space_separator: nombre(c, 2, ' ', ','), amount_with_apostrophe_separator: nombre(c, 2, "'", '.') }[k] ?? nombre(c, 2, '.', ','))); } };
  const estCouleur = (g) => g.dataset.optionNom === 'Couleur';
  const LIBELLE = 'Ajouter au panier';
  const aTaille = groupes.some((g) => !estCouleur(g));

  // Sélection courante : une valeur par option (null = pas encore choisie).
  const choix = groupes.map((g) => radios(g).find((b) => b.getAttribute('aria-checked') === 'true')?.dataset.value ?? null);
  const idx = (g) => Number(g.dataset.optionIndex);
  const correspond = (v, saufIndex) => groupes.every((g, i) => i === saufIndex || choix[i] === null || v.options[idx(g)] === choix[i]);

  // Disponibilité d'une valeur = une variante disponible porte cette valeur ET les autres choix déjà faits.
  // Calculée ici depuis le JSON (et non lue dans le HTML) : la fiche et le panier jugent sur la même donnée.
  const majDisponibilites = () => groupes.forEach((g, i) => radios(g).forEach((b) => {
    const ok = variantes.some((v) => v.available && v.options[idx(g)] === b.dataset.value && correspond(v, i));
    b.dataset.available = String(ok);
    if (ok) b.removeAttribute('aria-label'); else b.setAttribute('aria-label', `${b.dataset.value} — indisponible`);
  }));

  const resolue = () => (choix.every((c) => c !== null) ? variantes.find((v) => groupes.every((g, i) => v.options[idx(g)] === choix[i])) : undefined);

  const montrerAide = (texte, alerte) => { if (!aide) return; aide.textContent = texte; aide.setAttribute('role', alerte ? 'alert' : 'status'); aide.hidden = !texte; };

  const maj = () => {
    majDisponibilites();
    const v = resolue();
    const complet = choix.every((c) => c !== null);
    if (v) {
      champ.value = v.id;
      if (prix) prix.textContent = euros.format(v.price / 100);
    } else if (prix) {
      const candidates = variantes.filter((x) => correspond(x, -1));
      const p = [...new Set(candidates.map((x) => x.price))];
      if (p.length === 1) prix.textContent = euros.format(p[0] / 100);
      else if (p.length) prix.textContent = `Dès ${euros.format(Math.min(...p) / 100)}`;
    }
    if (complet && (!v || !v.available)) {
      bouton.disabled = true; bouton.textContent = aTaille ? 'Taille indisponible' : 'Indisponible';
      montrerAide('Cette taille est indisponible pour le moment. Choisissez-en une autre ou écrivez-nous pour la faire venir.', false);
    } else {
      bouton.disabled = false; bouton.textContent = LIBELLE;
      if (aide && aide.getAttribute('role') !== 'alert') montrerAide('', false);
    }
    if (v && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); }
    majBarre();
  };

  // Galerie (lot 6) : rail défilant ; points (mobile) et miniatures verticales (≥ 900 px) synchronisés sur la photo
  // courante ; à la souris, clic sur la moitié gauche / droite de la photo → précédente / suivante (curseur carré à
  // chevron). L'index courant est publié sur le rail (data-index) pour le zoom (moola-zoom.js).
  const rail = fiche.querySelector('[data-galerie]');
  const points = [...fiche.querySelectorAll('[data-galerie-points] [data-index]')];
  const vignettes = [...fiche.querySelectorAll('[data-galerie-vignettes] [data-index]')];
  const nbPhotos = rail ? rail.children.length : 0;
  const allerIndex = (i, doux = true) => { if (!rail || !nbPhotos) return; const n = Math.max(0, Math.min(nbPhotos - 1, i));
    rail.scrollTo({ left: n * rail.clientWidth, behavior: doux && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' }); };
  const allerA = (mediaId) => { const s = rail?.querySelector(`[data-media-id="${mediaId}"]`); if (s) allerIndex([...rail.children].indexOf(s)); };
  const courant = () => (rail ? Math.round(rail.scrollLeft / Math.max(rail.clientWidth, 1)) : 0);
  if (rail) {
    rail.dataset.index = '0';
    let t = 0;
    rail.addEventListener('scroll', () => { cancelAnimationFrame(t); t = requestAnimationFrame(() => {
      const n = courant(); rail.dataset.index = String(n);
      [...points, ...vignettes].forEach((b) => (Number(b.dataset.index) === n ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current')));
    }); }, { passive: true });
    [...points, ...vignettes].forEach((b) => b.addEventListener('click', () => allerIndex(Number(b.dataset.index))));
    rail.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); allerIndex(courant() + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); allerIndex(courant() - 1); } });
    // Moitiés cliquables (souris, ≥ 900 px) : curseur indiquant le sens.
    const souris = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 900px)');
    if (nbPhotos > 1) {
      rail.addEventListener('mousemove', (e) => { if (!souris.matches) return; const q = rail.getBoundingClientRect(); const gauche = e.clientX < q.left + q.width / 2;
        rail.classList.toggle('moola-galerie--gauche', gauche); rail.classList.toggle('moola-galerie--droite', !gauche); });
      rail.addEventListener('mouseleave', () => rail.classList.remove('moola-galerie--gauche', 'moola-galerie--droite'));
      rail.addEventListener('click', (e) => { if (!souris.matches) return; const q = rail.getBoundingClientRect(); allerIndex(courant() + (e.clientX < q.left + q.width / 2 ? -1 : 1)); });
    }
  }

  // Quantité [−] [n] [+] (min 1, max 99).
  const qte = form.querySelector('[data-qte-champ]');
  if (qte) {
    const borner = () => { qte.value = String(Math.max(1, Math.min(99, Math.trunc(Number(qte.value)) || 1))); };
    form.querySelector('[data-qte-moins]')?.addEventListener('click', () => { qte.value = String(Number(qte.value) - 1); borner(); });
    form.querySelector('[data-qte-plus]')?.addEventListener('click', () => { qte.value = String(Number(qte.value) + 1); borner(); });
    qte.addEventListener('change', borner);
  }

  // Barre d'achat collante (lot 6) : visible dès que le bouton principal n'est plus ENTIÈREMENT à l'écran sous l'en-tête
  // (au-dessus ou en dessous) et qu'aucun sélecteur n'est à l'écran ; masquée quand le pied de page entre à l'écran. Aucune zone morte : l'observateur retranche la hauteur de
  // l'en-tête (relue à chaque changement de taille).
  const barre = document.querySelector('[data-barre-achat]');
  const barreBouton = barre?.querySelector('[data-barre-bouton]');
  const barrePrix = barre?.querySelector('[data-barre-prix]');
  if (barre && 'IntersectionObserver' in window) {
    // Masquée aussi tant qu'un sélecteur (pointure, taille, coloris) est à l'écran : elle ne recouvre jamais les pastilles
    // qu'on est en train de toucher (mesuré : sans cela, une pastille amenée en bas d'écran passait sous la barre).
    let principalVu = true, piedVu = false, obs = null; const selecteursVus = new Set();
    // Encombrement de la barre visible (hauteur + distance au bas de l'écran) publié dans --moola-barre-h, 0 quand elle est
    // masquée : le scroll-padding-bottom de la page en tient compte, un élément qui reçoit le focus clavier n'est jamais
    // amené dessous (revue du 04/10 : bouton d'ajout rapide du rail recouvert à 100 %). offsetHeight + bottom calculé, pas
    // getBoundingClientRect : la barre est encore en translation au moment où elle apparaît.
    // Et quand la barre APPARAÎT (souvent à cause du défilement qu'une tabulation vient de provoquer), elle dégage l'élément
    // qui a le focus clavier s'il se retrouve dessous (mesuré : carte focalisée couverte aux 3/10 par la barre apparue après).
    const racine = document.documentElement; let barreVue = false;
    const afficher = () => { const vis = !principalVu && !piedVu && selecteursVus.size === 0; barre.classList.toggle('est-visible', vis); barre.setAttribute('aria-hidden', String(!vis)); if (barreBouton) barreBouton.tabIndex = vis ? 0 : -1;
      racine.style.setProperty('--moola-barre-h', vis ? Math.ceil(barre.offsetHeight + (parseFloat(getComputedStyle(barre).bottom) || 0)) + 'px' : '0px');
      const apparait = vis && !barreVue; barreVue = vis;
      const a = document.activeElement;
      if (apparait && a && a !== document.body && !barre.contains(a) && a.matches(':focus-visible')) {
        const r = a.getBoundingClientRect(); const bas = innerHeight - (parseFloat(getComputedStyle(racine).scrollPaddingBottom) || 0);
        if (r.bottom > bas && r.top < innerHeight) a.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      } };
    const observer = () => { obs?.disconnect(); const h = document.querySelector('[data-moola-entete]')?.offsetHeight || 0;
      // « Visible » = ENTIÈREMENT visible : un bouton dont ne dépasse qu'une lisière n'est pas cliquable (mesuré : trous à
      // 120-160 px et 920-960 px de défilement quand la barre se cachait au premier pixel du bouton).
      obs = new IntersectionObserver((e) => { principalVu = e[0].intersectionRatio >= 0.99; afficher(); }, { rootMargin: `-${h}px 0px 0px 0px`, threshold: [0, 0.5, 0.99, 1] }); obs.observe(bouton); };
    observer(); window.addEventListener('resize', observer);
    const obsSel = new IntersectionObserver((e) => { e.forEach((x) => (x.isIntersecting ? selecteursVus.add(x.target) : selecteursVus.delete(x.target))); afficher(); });
    fiche.querySelectorAll('.moola-infos .picker').forEach((f) => obsSel.observe(f));
    const pied = document.querySelector('footer');
    if (pied) new IntersectionObserver((e) => { piedVu = e[0].isIntersecting; afficher(); }).observe(pied);
  }
  const majBarre = () => {
    if (!barreBouton) return;
    if (prix && barrePrix) barrePrix.textContent = prix.textContent;
    barreBouton.disabled = bouton.disabled;
    const manque = groupes.findIndex((g, i) => !estCouleur(g) && choix[i] === null);
    if (bouton.disabled) { barreBouton.textContent = bouton.textContent; return; }
    if (manque >= 0) { const nom = groupes[manque].dataset.optionNom.toLowerCase(); barreBouton.textContent = nom === 'pointure' || nom === 'taille' ? `Choisir ma ${nom}` : `Choisir : ${groupes[manque].dataset.optionNom}`; return; }
    const taille = groupes.find((g, i) => !estCouleur(g) && choix[i] !== null && radios(g).length > 1);
    barreBouton.textContent = taille ? `${LIBELLE} — ${choix[groupes.indexOf(taille)]}` : LIBELLE;
  };

  const choisir = (g, b) => {
    const i = groupes.indexOf(g);
    choix[i] = b.dataset.value;
    radios(g).forEach((x) => x.setAttribute('aria-checked', String(x === b)));
    if (estCouleur(g) && libCouleur) libCouleur.textContent = b.dataset.value;
    else { const leg = g.closest('fieldset')?.querySelector('[data-size-valeur]'); if (leg) leg.textContent = b.dataset.value; }
    if (aide?.getAttribute('role') === 'alert') montrerAide('', false);
    if (etat) etat.textContent = '';
    maj();
    const v = resolue() ?? (estCouleur(g) ? variantes.find((x) => x.options[idx(g)] === b.dataset.value && x.featured_media) : undefined);
    if (v?.featured_media) allerA(v.featured_media.id);
    itinerant(g);
  };

  // Tabindex itinérant + clavier (repris du 24/08).
  const itinerant = (g) => { const r = radios(g); const n = r.findIndex((x) => x.getAttribute('aria-checked') === 'true'); r.forEach((x, i) => { x.tabIndex = i === (n === -1 ? 0 : n) ? 0 : -1; }); };
  groupes.forEach((g) => {
    radios(g).forEach((b) => b.addEventListener('click', () => choisir(g, b)));
    g.addEventListener('keydown', (e) => {
      const r = radios(g); const a = r.indexOf(document.activeElement); if (a < 0) return;
      let n = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (a + 1) % r.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (a - 1 + r.length) % r.length;
      else if (e.key === 'Home') n = 0; else if (e.key === 'End') n = r.length - 1; else return;
      e.preventDefault(); r[n].focus(); r[n].click();
    });
    itinerant(g);
  });

  let enCours = false, minuterie = 0;
  form.addEventListener('submit', async (e) => {
    const manque = groupes.findIndex((g, i) => choix[i] === null);
    if (manque >= 0) {
      e.preventDefault();
      const nom = groupes[manque].dataset.optionNom.toLowerCase();
      montrerAide(nom === 'pointure' || nom === 'taille' ? `Choisissez votre ${nom}` : `Choisissez : ${groupes[manque].dataset.optionNom}`, true);
      radios(groupes[manque])[0]?.focus();
      return;
    }
    e.preventDefault();
    if (enCours || bouton.disabled) return;
    enCours = true; bouton.setAttribute('aria-busy', 'true');
    // Deux temps séparés : seul un échec de l'AJOUT justifie le repli par envoi classique. Si l'ajout a réussi et que
    // seule la relecture du panier échoue (réseau, 429 HTML), resoumettre ajouterait l'article une seconde fois.
    let r;
    // Lot 2 « façon Loban » : la même requête renvoie le HTML du panier latéral (Section Rendering) — une requête par geste.
    const donnees = new FormData(form);
    if (window.MoolaPanier) { donnees.append('sections', 'moola-panier-tiroir'); donnees.append('sections_url', location.pathname); }
    try {
      r = await fetch('/cart/add.js', { method: 'POST', body: donnees, headers: { Accept: 'application/json' } });
    } catch {
      enCours = false; bouton.removeAttribute('aria-busy');
      form.submit();   // ajout injoignable : envoi classique, Shopify redirige vers le panier
      return;
    }
    try {
      if (!r.ok) { const j = await r.json().catch(() => ({})); if (etat) etat.textContent = j.description || 'Ajout impossible pour le moment.'; return; }
      bouton.textContent = 'Ajouté au panier';
      if (etat) etat.innerHTML = 'Article ajouté — <a href="/cart">voir le panier</a>';
      clearTimeout(minuterie); minuterie = setTimeout(() => { if (!bouton.disabled) bouton.textContent = LIBELLE; }, 2600);
      // Panier latéral : la réponse porte son HTML → il s'ouvre seul (l'ouverture confirme l'ajout) et met la pastille à jour.
      const j = await r.json().catch(() => null);
      const html = j && j.sections && j.sections['moola-panier-tiroir'];
      if (html && window.MoolaPanier && window.MoolaPanier.afficher(html, { ouvrir: true, declencheur: bouton })) return;
      // Repli (réponse sans le tiroir) : relecture du panier pour la pastille, comme avant le lot 2.
      try {
        const panier = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        document.dispatchEvent(new CustomEvent('moola:panier', { detail: { item_count: panier.item_count } }));
      } catch { /* relecture impossible : l'article est ajouté, la pastille se mettra à jour à la page suivante */ }
    } finally { enCours = false; bouton.removeAttribute('aria-busy'); }
  });

  maj();
})();
